import { render, staticRenderFns } from "./SliTeamFields.vue?vue&type=template&id=ccba6fc6"
import script from "./SliTeamFields.vue?vue&type=script&lang=js"
export * from "./SliTeamFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports